import { Result } from '../../../../../common/models/Result';
import { SearchInputFilter } from '../../../../../common/models/SearchInputFilter';
import { SearchOutput } from '../../../../../common/models/SearchOutput';
import { HttpServiceBase } from '../../../../../common/services/HttpServiceBase';
import { SearchMemberAccount } from '../../../../models/SearchMemberAccount';

export class SearchMemberAccountService extends HttpServiceBase {

  handle = (input: SearchMemberAccountInput, bearerToken: string): Promise<Result<SearchMemberAccountOutput> | null> => {
    const promise = this.http.post<Result<SearchMemberAccountOutput>, SearchMemberAccountInput>(
      `${this.baseUrlZerezesApi}/club-pdv/member-account-search`,
      input,
      false,
      bearerToken
    );
    return promise;
  }
}

export class SearchMemberAccountInput extends SearchInputFilter {
  email: string;
}

export class SearchMemberAccountOutput extends SearchOutput {
  list: SearchMemberAccount[];
}